module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-top-stone-path-background-remnants.f7e59363.png";